import React from "react";
import { Box, Grid } from "atoms";

import { ResetSuccess as ResetSuccessForm } from "molecules";

const ResetSuccess = () => {
  return (
    <Box h="100vh">
      <Grid aI="center" h="100vh" px="12rem">
        <ResetSuccessForm />
      </Grid>
    </Box>
  );
};

export default ResetSuccess;
